export const blockIconsSocialRecyclingNew = (
	<span className='material-symbols-outlined'>recycling</span>
);
